import { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { retrieveIndex, retrieveUpdateIndex } from "../../../Services/IndexApiService";
import { retrieveStockSession } from "../../../Services/StockSessionApiService";
import $ from 'jquery';
import { DateTimer } from "../../Timer/dateTimer";
import { useAuthHeader } from "../../../auth/AuthService";

export default function HistoryIndexData2({lang}) {
    
    var START = 1;
    var IN_PROGRESS = 2;
    var MARKET_CLOSING = 99;
    const [STATE, setSTATE] = useState(START);
    const {t, i18n} = useTranslation();
    const authHeader = useAuthHeader();
    
    const [bPrice, setBPrice] = useState();
    const [oPrice, setOPrice] = useState();
    const [hPrice, setHPrice] = useState();
    const [lPrice, setLPrice] = useState();
    const [vol, setVol] = useState();
    const [val, setVal] = useState();
    const [cPrice, setCPrice] = useState();
    
    async function check() {
        await retrieveStockSession(authHeader())
        .then((response) => {
            if (response.data.data.session) {
                setSTATE(MARKET_CLOSING);
            }
        })
        .catch((error) => console.log(error));
    }

    async function updateIndexInfo() {
        await retrieveIndex(authHeader())
        .then((response) => {
            let data = response.data.data;
            setCPrice(data.CIndex);
            let change = (data.CPDay);
            let perChange = ((100 * Math.abs(data.CPDay) / data.CIndex));
            $('#index-change').html("&#x25B2; "+ Math.abs(change) +" ("+ perChange.toFixed(2)+"%)");
            if (data.CPDay > 0) {
                $('#index-change').html("&#x25B2; "+ Math.abs(change) +" ("+ perChange.toFixed(2)+"%)");
                $('#index-change').removeAttr("class")
                $('#index-change').addClass("text-green")

            } else if (data.CPDay < 0) {
                $('#index-change').html("&#x25BC; "+ Math.abs(change) +" ("+ perChange.toFixed(2)+"%)");
                $('#index-change').removeAttr("class")
                $('#index-change').addClass("text-red")
            } else {
                $('#index-change').html("&#x25B2; "+ Math.abs(change) +" ("+ perChange.toFixed(2)+"%)");
                $('#index-change').removeAttr("class")
                $('#index-change').addClass("text-white")
            }
            
        })
        .catch((error) => console.log(error));

        await retrieveUpdateIndex(authHeader())
        .then((response) => {
            let data = response.data.data;
            setBPrice(data.previndex);
            setOPrice(data.cindex);
            setHPrice(data.minmax.max);
            setLPrice(data.minmax.min);
            setVol(data.tquantity);
            setVal(data.tturnover);
        })
        .catch((error) => console.log(error));

        check();
    }

    useEffect(() => {
        updateIndexInfo();

        var intervalPrice = setInterval(updateIndexInfo, 5000);

        if (STATE == MARKET_CLOSING && (new Date().setHours(15,10,0)) < (new Date().getTime())) {
            clearInterval(intervalPrice);
        }

        return () => {
            clearInterval(intervalPrice);
        }
    }, [lang]);

    return (
        <div className="grid md:text-lg text-sm">
            <div className="col-12 flex justify-content-between">
                <span className="md:text-xl font-bold">{t('Current Index')} : {cPrice && cPrice.toLocaleString('en-US')} &nbsp;
                    <span id="index-change"></span>
                </span>
                <span className="font-bold">{t('Date')} : <DateTimer type={1}/>  (<DateTimer type={3}/>)</span>
            </div>
                
            <div className="col-12">
                <span className="font-bold mb-0">
                    {t('Previous Index')}  : {bPrice ? bPrice.toLocaleString('en-US') : '-'}&nbsp;&nbsp;
                    {t('Open (Top)')} : <span className={oPrice && oPrice != bPrice ? (oPrice > bPrice ? 'text-green' : 'text-red') : ''}>{oPrice ? oPrice.toLocaleString('en-US') : '-'}</span>   &nbsp;&nbsp;
                    {t('High (Top)')} : <span className={hPrice && hPrice != bPrice ? (hPrice > bPrice ? 'text-green' : 'text-red') : ''}>{hPrice ? hPrice.toLocaleString('en-US') : '-'}</span>  &nbsp;&nbsp; 
                    {t('Low (Top)')} : <span className={lPrice && lPrice != bPrice ? (lPrice > bPrice ? 'text-green' : 'text-red') : ''}>{lPrice ? lPrice.toLocaleString('en-US') : '-'}</span>   &nbsp;&nbsp;
                    {t('Volume')} ({t('shr')}) : <span>{vol ? vol.toLocaleString('en-US') : 0}</span> &nbsp;&nbsp;
                    {t('Value')} ({t('KHR')}) : <span>{val ? val.toLocaleString('en-US') : 0}</span> &nbsp;&nbsp;
                </span>
            </div>
        </div>
    )
}